import React, { PropTypes } from 'react';
import { Panel, PanelHeader, Pre, Text } from 'rebass';
import { findNextWord, recase, spoonerizePhrase } from '../lib/Spoonerism';
import { parsePhrase } from '../lib/Words';

const propTypes = {
  phrase: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['primary', 'secondary', 'default', 'info', 'success', 'warning', 'error']).isRequired,
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  theme: 'info',
};

function replaceSegment(words, index) {
  const word = words[index];
  const nextWord = findNextWord(index, words);
  const prefixA = word.segments[0] ? recase(word.segments[0], word.capitals) : 'blank';
  const prefixB = nextWord.segments[0] ? recase(nextWord.segments[0], nextWord.capitals) : 'blank';
  return (
    <span key={word.word}>
      {index + 1}. Repalace the <strong>"{prefixA}"</strong> in <strong>"{word.word}"</strong>
      {' '}with the <strong>"{prefixB}"</strong> from <strong>"{nextWord.word}"</strong>
      <br />
    </span>
  );
}

function renderFragments(phrase) {
  const words = parsePhrase(phrase);
  return words.map(({spoonerable}, i) => {
    if (!spoonerable) {
      return null;
    }
    return replaceSegment(words, i);
  });
}

export default function ExamplePanel({phrase, title, ...props}) {
  const spoonerism = spoonerizePhrase(phrase);
  return (
    <Panel {...props}>
      <PanelHeader>
        Example: {title}
      </PanelHeader>
      <Text>
        To spoonerize <strong>"{phrase}"</strong>:
      </Text>
      <Pre>
        {renderFragments(phrase)}
      </Pre>
      <Text>
        The spoonerism is <strong>"{spoonerism}"</strong>.
      </Text>
    </Panel>
  );
}

ExamplePanel.propTypes = propTypes;
ExamplePanel.defaultProps = defaultProps;



/** WEBPACK FOOTER **
 ** ./src/components/ExamplePanel.js
 **/